// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewPreparedFpsTransferAPIModel
 */
export interface NewPreparedFpsTransferAPIModel {
    /**
     * 
     * @type {string}
     * @memberof NewPreparedFpsTransferAPIModel
     */
    messageId: string;
    /**
     * 
     * @type {string}
     * @memberof NewPreparedFpsTransferAPIModel
     */
    bankId: string;
    /**
     * 
     * @type {string}
     * @memberof NewPreparedFpsTransferAPIModel
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof NewPreparedFpsTransferAPIModel
     */
    description?: string;
}

export function NewPreparedFpsTransferAPIModelFromJSON(json: any): NewPreparedFpsTransferAPIModel {
    return NewPreparedFpsTransferAPIModelFromJSONTyped(json, false);
}

export function NewPreparedFpsTransferAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewPreparedFpsTransferAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'bankId': json['bankId'],
        'amount': json['amount'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function NewPreparedFpsTransferAPIModelToJSON(value?: NewPreparedFpsTransferAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'bankId': value.bankId,
        'amount': value.amount,
        'description': value.description,
    };
}


